import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoCircleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 6C11.448 6 11 6.448 11 7C11 7.552 11.448 8 12 8C12.552 8 13 7.552 13 7C13 6.448 12.552 6 12 6ZM12 9.6C11.613 9.6 11.3 9.913 11.3 10.3V17.7C11.3 18.087 11.613 18.4 12 18.4C12.387 18.4 12.7 18.087 12.7 17.7V10.3C12.7 9.913 12.387 9.6 12 9.6Z",
		fill: "currentColor"
	})
});
export default SvgInfoCircleFill;
